import { ReactElement } from 'react';
import { paymentStateOptions } from './options';
import { applicationStateOptions } from 'core/types';
import { SelectFilterChip } from 'components/filters/SelectFilterChip';
import { FilterSeparator } from 'components/filters/FilterSeparator';

const bookedOptions = [
  { value: 'true', label: 'Booked' },
  { value: 'false', label: 'Not booked' },
];

const linkedOptions = [
  { value: 'true', label: 'Linked' },
  { value: 'false', label: 'Not linked' },
];

export function StateFilters(): ReactElement {
  return (
    <>
      <FilterSeparator />
      <SelectFilterChip name="payment_state" label="Payment" options={paymentStateOptions} />
      <SelectFilterChip name="booked" options={bookedOptions} />
      <SelectFilterChip name="linked" options={linkedOptions} />
      <SelectFilterChip name="sums__link_state" label="Links" options={applicationStateOptions} isMulti />
    </>
  );
}
